export default [
  {
    path: "/eDCBNI/Currency",
    name: "PCInternet",
    component: () => import("@/pages/pc"),
    meta: {
      title: "互联网申报",
      type: "Currency"
    },
    children: [
      {
        path: "/pc/",
        redirect: "/eDCBNI/Currency/Declaration"
      },
      {
        path: "/eDCBNI/Currency/Declaration",
        name: "PCInternetDeclaration",
        component: () => import("@/pages/pc/InternetDeclaration.vue"),
        meta: {
          title: "互联网申报",
          type: "pc"
        }
      },
      {
        path: "/eDCBNI/Currency/List",
        name: "PCInternetList",
        component: () => import("@/pages/pc/InternetList.vue"),
        meta: {
          title: "互联网申报列表",
          type: "pc"
        }
      }
    ]
  }
];